import type { IImage, IVideo } from './media';

export enum InputType {
  TEXT = 'text',
  IMAGE = 'image',
  VIDEO = 'video',
}

interface IBaseInput {
  type: InputType;
  id: string;
  title?: string;
  paramKey?: string;
  // Set by the flow's `cms-schema` and forwarded by the CMS: the flow accepts this
  // input being left empty. Optional inputs don't gate Generate (`isFormValid`) and
  // are dropped from the webhook payload when empty (`buildParamsFromInputs`).
  optional?: boolean;
}

export interface ITextInput extends IBaseInput {
  type: InputType.TEXT;
  value: string;
  placeholder?: string;
  suggestions?: string[];
}

export interface IImageInput extends IBaseInput, Omit<IImage, 'src'> {
  type: InputType.IMAGE;
  src?: string | null;
  isLoading?: boolean;
  hasUploadError?: boolean;
}

export interface IVideoInput extends IBaseInput, Omit<IVideo, 'src'> {
  type: InputType.VIDEO;
  src?: string | null;
  isLoading?: boolean;
  hasUploadError?: boolean;
}

export type IInput = ITextInput | IImageInput | IVideoInput;
export type IMediaInput = IImageInput | IVideoInput;
